module.exports = "<div layout=row class=gz-header-template-container><div id=agHeaderCellLabel class=gz-header-template-cell-label><div id=agText class=gz-header-template-text></div></div><div id=agResizeBar class=gz-header-template-resize-bar></div></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/extensions/grid/grid-header-template.jade
// module id = 255
// module chunks = 0